import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiBaseService } from "../../common/providers/api-base-service";
import { map } from 'rxjs/operators';
import { Moment } from 'moment';
import { UrlFormatter } from "../../common/http/url-formatter";
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { Exercise } from "../../common/models/stats/exercise";
import { Accent } from "../../common/models/stats/accent";
import { AccentHour } from "../../common/models/stats/accent-hour";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({providedIn: 'root'})
export class StatsService {
    constructor(
        private api: ApiBaseService,
        private urlFormatter: UrlFormatter,
        private currentUser: CurrentUser,
    ) {}

    public getExercisesPerformedDataByDate(organization: Organization, athlete: Athlete, dateFrom: Moment, dateTo: Moment): Observable<any> {
        this.urlFormatter.query.add('from', dateFrom.format('YYYY-MM-DD'));
        this.urlFormatter.query.add('to', dateTo.format('YYYY-MM-DD'));

        return this.api.call('get',this.urlFormatter.createUrl(`organizations/${organization.id}/athletes/${athlete.userId}/stats/exercises`), {}, this.currentUser.getAccessToken()).pipe(
            map((data) => data['exercises'].map(
                (res: any) => {
                    const exercise = this.castToModel(res, Exercise);
                    exercise.totalOccurrence = data['total'];

                    return exercise;
                }
            )),
        );
    }

    public getAccentsPerformedDataByDate(organization: Organization, athlete: Athlete, dateFrom: Moment, dateTo: Moment): Observable<any> {
        this.urlFormatter.query.add('from', dateFrom.format('YYYY-MM-DD'));
        this.urlFormatter.query.add('to', dateTo.format('YYYY-MM-DD'));

        return this.api.call('get',this.urlFormatter.createUrl(`organizations/${organization.id}/athletes/${athlete.userId}/stats/accents`), {}, this.currentUser.getAccessToken()).pipe(
            map((data) => data['accents'].map(
                (res: any) => {
                    const accent = this.castToModel(res, Accent);
                    accent.totalOccurrence = data['total'];

                    return accent;
                }
            )),
        );
    }

    public getAccentsHoursPerformedDataByDate(organization: Organization, athlete: Athlete, dateFrom: Moment, dateTo: Moment): Observable<any> {
        this.urlFormatter.query.add('from', dateFrom?.format('YYYY-MM-DD'));
        this.urlFormatter.query.add('to', dateTo?.format('YYYY-MM-DD'));

        return this.api.call('get',this.urlFormatter.createUrl(`organizations/${organization.id}/athletes/${athlete.userId}/stats/accents-hours`), {}, this.currentUser.getAccessToken()).pipe(
            map((data) => data['accents'].map(
                (res: any) => {
                    const accent = this.castToModel(res, AccentHour);
                    accent.totalSecond = data['total'];

                    return accent;
                }
            )),
        );
    }

    private castToModel<T>(data: any, model: new (...args: any[]) => T ): T {
        const classInstance: any = new model();
        const classProps = Object.getOwnPropertyNames(classInstance);

        classProps.forEach((prop) => classInstance[prop] = data[prop]);

        return classInstance;
    }
}
